/**
 * External Dependencies
 */
import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';
import 'jquery';
import Alpine from 'alpinejs';
import AOS from 'aos';
import { tns } from 'tiny-slider/src/tiny-slider';

// Stimulus
window.Stimulus = Application.start();
const context = require.context("./controllers", true, /\.js$/);
Stimulus.load(definitionsFromContext(context));

window.Alpine = Alpine
Alpine.start()

let scrollpos = window.scrollY
const header = document.querySelector("header.hideme")
const feature = document.querySelector("#feature")


  setTimeout(function(){
    console.log('boomtown')
    // const header_height = feature.offsetHeight
    const header_height = 200
    const add_class_on_scroll = () => header.classList.remove("-translate-y-full")
    const remove_class_on_scroll = () => header.classList.add("-translate-y-full")
    window.addEventListener('scroll', function() { 
      console.log('scrolling')
      scrollpos = window.scrollY;
      if (scrollpos >= header_height) { add_class_on_scroll() }
      else { remove_class_on_scroll() }
      //console.log(scrollpos)
    })
  },1000)


if(header){
  document
    .querySelectorAll('header li a[href^="#"]')
    .forEach(trigger => {
        trigger.onclick = function(e) {
            e.preventDefault();
            let hash = this.getAttribute('href');
            let target = document.querySelector(hash);
            let headerOffset = 100;
            let elementPosition = target.offsetTop;
            let offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        };
    });
}

$(() => {
  AOS.init({
    duration:   1200,
    once:       false,
  })
  if (document.querySelectorAll('.my-slider').length > 0) {
    const slider = tns({
      container: '.my-slider',
      items: 1,
      mode: 'gallery',
      autoplay: true,
      autoplayButtonOutput: false,
      loop: true,
      speed: 400,
      controlsContainer: "#quotes-controls",
    });
  }
  if (document.querySelectorAll('.carousel_mobile').length > 0) {
    const carousel = tns({
      container: '.carousel_mobile',
      items: 1,
      mode: 'gallery',
      autoplay: true,
      loop: true,
      controls: false,
      nav: false,
      autoplayButtonOutput: false,
      // swipeAngle: false,
      speed: 1200,
    });
  }
  if (document.querySelectorAll('.carousel').length > 0) {
    const carousel = tns({
      container: '.carousel',
      items: 1,
      mode: 'gallery',
      autoplay: true,
      loop: true,
      controls: false,
      nav: false,
      autoplayButtonOutput: false,
      // swipeAngle: false,
      speed: 1200,
    });
  }
  if (document.querySelectorAll('.spotlight').length > 0) {
    const spotlight = tns({
      container: '.spotlight',
      items: 1,
      gutter: 40,
      // autoWidth: true,
      loop: true,
      speed: 600,
      responsive: {
      1024: {
        items: 2
      }
    }
    });
  }
});

